<template>
  <a-modal
    v-model="visible"
    v-if="visible"
    title="导出"
    width="600px"
    destroyOnClose
    @ok="ok"
    @cancel="cancel"
    cancelText="取消"
    okText="确定"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="报表类型">
        配方对比报表
      </a-form-item>
      <a-form-item label="文件名称">
        <a-input v-decorator="['fileName', { rules: [
          { required: true, message: '请输入文件名称' },
          {validator: this.validatorName, trigger: 'change'}
        ] }]" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import moment from 'moment'
export default {
  props: ['visible','formData','productIdList'],
  data() {
    return {
      form: this.$form.createForm(this),
      maxLen2: 40
    }
  },
  watch: {
    visible(val){
      if(val) setTimeout(() => {
        this.form.setFieldsValue({fileName: `配方对比报表${moment(new Date()).format('YYYYMMDDHHmmSS')}`})
      }, 0);
    }
  },
  methods: {
    validatorName(rule, value, callback) {
      let msg = ''
      let reg2 = /[*[\]：？<>/、\\.]/im;
      if(reg2.test(value)){
        msg = '文件名称不能包含*[]：？<>/、\\.等特殊字符'
      }
      let len = value.length
      if(len > this.maxLen2){
        msg = `文件名称长度不能超过${this.maxLen2}个字符`
      }
      if(msg) callback(new Error(msg))
      callback()
    },
    turnTo(){
      this.$router.push('/system/nhf-export-management?name=导出管理')
      this.$notification.close('a')
    },
    ok() {
      this.form.validateFields((err,values) => {
        if(!err){
          let params = {
            ...this.formData,...values,
            productIdList: this.productIdList,
          }
          this.$http.post('/nhf-app/formulaproductext/asyncExportProductListContrastTask',params)
          this.$notification.success({
            key: 'a',
            message: <h3>导出任务提示</h3>,
            duration: 3,
            description: <div>
              <p>你所提交的导出任务已经创建，请前往导出管理中查看进度和下载文件！</p>
              <a onClick={this.turnTo}>前往导出管理</a>
            </div>,
          });
          this.$emit('close')
        }
      })
    },
    cancel() {
      this.$emit('close')
    },
  }
}
</script>